<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/DateTime/NewDDateTimePreview'
export default {
  name: 'NewDBirthdayPreview',
  extends: compoment
}
</script>
<style lang="scss">
.d-datetime-preview.z-draggable-preview {
  // .el-input__prefix {
  //   left: -8px;
  // }
  // .el-input__inner {
  //   padding-left: 20px !important;
  // }
  // .el-date-picker.el-popper {
  //   left: -4px !important;
  // }
}
</style>
